import { Billing } from './Billing'
import { MealDate } from './MealDate'

export class MealDateRequestDTO {

    mealDate : MealDate
    billing? : Billing
    day? : number
    description? : string
    mealid? : number

    constructor(mealDate : MealDate, billing?: Billing, day? : number, description? : string, mealid? : number) {
        this.mealDate = mealDate
        this.billing = billing
        this.day = day
        this.mealid = mealid
        this.description = description
    }

}